"use client";

import { Check, Copy, Ellipsis, FolderInput, Trash2, Upload } from "lucide-react";
import { useTranslations } from "next-intl";
import { AdminTableIconActionButton } from "@/components/admin/admin-table-icon-actions";
import { useClipboardCopy } from "@/components/ui/copy-button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import type { AttachFileRecord } from "./types";

export function AttachFileActions({ file, disabled, className, onOpenChange, onReplace, onMove, onDelete }: {
  file: AttachFileRecord; disabled?: boolean; className?: string; onOpenChange: (open: boolean) => void;
  onReplace?: (file: AttachFileRecord) => void; onMove: (file: AttachFileRecord) => void; onDelete: (id: string) => void;
}) {
  const t = useTranslations("site.attach");
  const clipboard = useClipboardCopy({ value: file.url, successText: "已复制到剪贴板", errorText: "复制失败，请手动复制" });
  const readOnly = disabled || file.owned === false;
  return <DropdownMenu onOpenChange={onOpenChange}>
    <AdminTableIconActionButton label={t("fileActions")} icon={Ellipsis} tone="primary" className={cn("border-0 shadow-none data-popup-open:text-primary", className)} render={<DropdownMenuTrigger disabled={disabled} />} />
    <DropdownMenuContent align="end" className="w-max min-w-0">
      <DropdownMenuItem disabled={clipboard.disabled} onClick={() => void clipboard.copy()}>{clipboard.copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}{t("copyLink")}</DropdownMenuItem>
      {onReplace && <DropdownMenuItem disabled={readOnly} onClick={() => onReplace(file)}><Upload className="size-3.5" />{t("overwriteFile")}</DropdownMenuItem>}
      <DropdownMenuItem disabled={readOnly} onClick={() => onMove(file)}><FolderInput className="size-3.5" />{t("moveFile")}</DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem variant="destructive" disabled={readOnly} onClick={() => onDelete(file.id)}><Trash2 className="size-3.5" />{t("deleteFile")}</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>;
}
